// Angular
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, } from '@angular/core';
// Service
import { AppService, ErrorFactoryService } from '@cv-invision/core';
import { BroadcastService } from 'libs/core/src/lib/service/broadcast.service';
import {DialogService} from 'primeng/dynamicdialog';
// Component
import { DMLicenseDialogComponent } from '../dm-license-dialog/dm-license-dialog.component';
// State
import { Select, Store } from '@ngxs/store';
import { ErrorTrackState } from '../../../../error-track/error-track.state';
// Model
import {  CERTIFICATION_TYPE, ERROR_TYPE } from '@cv-invision/core';
// Other
import { Observable, Subject } from 'rxjs';

@Component({
	selector: 'cv-user-info-header',
	templateUrl: './user-info-header.component.html',
	styleUrls: ['./user-info-header.component.scss'],
})
export class UserInfoHeaderComponent implements OnInit {
	@Select(ErrorTrackState.exceptionErrorList) exceptionErrorTrack$: Observable<any>;
	@ViewChild('userProfile', { static: false }) userProfile: ElementRef<any>;
	@ViewChild('profileButton', { static: false }) profileButton: ElementRef<any>;
	@Input() profile: Observable<any>;
	@Input() toggleUser: boolean;
	@Input() user: any;
	public atComponentDestroy = new Subject();
	public meProfile: any;
	private clickUserProfileListener: any;
	public nameInitials: string;
	public errorReport: any = null;
	public isDMLicensed = false;
	protected certificationTypes = CERTIFICATION_TYPE;

	get isSMSEnabled(): any {
		return this.appService.isSMSEnabled(this.store);
	}

	constructor(
		private renderer: Renderer2,
		private broadcastService: BroadcastService,
		private errorFactoryService: ErrorFactoryService,
		private appService: AppService,
		protected dialogService: DialogService,
		private store : Store
	) {
	}

	ngOnInit(): void {
		if (this.toggleUser) {
			this.toggleUserProfile();
		}
		this.profile.subscribe( (profile: any) => {
			if (profile && profile.classUserId) {
				this.meProfile = profile;
			}
			this.isDMLicensed = profile && profile.isDMLicensed;
		});
	}

	public getCertificationType(type : string){
		const index = this.certificationTypes.findIndex(cert => cert.type === type);
		if(index > -1){
			return this.certificationTypes[index].label;
		}

		return type;
	}

	/**
	 * Open the User Profile
	 */
	public toggleUserProfile(): void {
		const { nativeElement } = this.profileButton;
		const { nativeElement: el } = this.userProfile;
		if (el.style.display !== 'block') {
			const top = nativeElement.offsetTop + nativeElement.offsetHeight;
			this.renderer.setStyle(el, 'top', `${top + 25}px`);
			this.renderer.setStyle(el, 'display', 'block');
			this.registerUserProfileClickListener();
		} else {
			this.renderer.setStyle(el, 'display', 'none');
			if (this.clickUserProfileListener) {
				this.clickUserProfileListener();
			}
		}

		const lastErrors = this.errorFactoryService.retrieveLatestCodeErrors([ERROR_TYPE.REQUEST, ERROR_TYPE.LOG], true, false);
		if (lastErrors !== null) {
			this.errorReport = lastErrors;
		}

	}

	/**
	 * Register a document:click event listener ONLY when inbox opens up in order
	 * to close the inbox by clicking outside of it. This event is destroyed whenever the
	 * inbox is closed either by toggle button or outside click.
	 */
	registerUserProfileClickListener(): void {
		setTimeout(() => {
			this.clickUserProfileListener = this.renderer.listen(
				'document',
				'click',
				(event) => {
					const targetElement = event.target;
					const el = this.userProfile.nativeElement;
					const clickedOutside = !el.contains(targetElement);
					if (clickedOutside) {
						this.renderer.setStyle(el, 'display', 'none');
						this.clickUserProfileListener();
					}
				}
			);
		}, 100);
	}

	/**
	 * Review the status of your License for DM
	 */
	public dmLicenseStatus(): void {
		// Open the Dialog in a new State
		this.dialogService.open(DMLicenseDialogComponent,
			{
				header: 'License Status',
				width: '32.5rem',
				styleClass: 'desktop-dialog header-dialog',
				data: {
					isDMLicensed: this.isDMLicensed
				},
			}
		).onClose.subscribe(async (result: any): Promise<void> => {
			//
		});
	}

	/**
	 * Open settings dialog
	 */
	public openSMSSettingsView() {
		this.broadcastService.broadcast({
			name: 'OPEN_SETTINGS_DIALOG',
			event: {}
		});
	}
}
